import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, switchMap, tap } from 'rxjs';

import {
  USER_MANAGEMENT_ACTIONS,
  USER_MANAGEMENT_DIALOG_ACTIONS,
} from '../actions';
import { AdminService } from '@admin/admin.service';
import { catchError } from 'rxjs/operators';

@Injectable()
export class UserManagementEffects {
  private readonly _actions$ = inject(Actions); 
  private readonly _adminService = inject(AdminService);  
  private readonly _matDialog = inject(MatDialog);  
  
  /**
   * @USERMANAGEMENT ACTIONS
   * */
  updateIrisId$ = createEffect(() =>
    this._actions$.pipe(
      ofType(USER_MANAGEMENT_ACTIONS.updateEditIrisId),
      switchMap(({ data }) =>
        this._adminService.updateUser(data.id!, data).pipe(
          switchMap((response) => {
            return [
              USER_MANAGEMENT_ACTIONS.onUpdateEditIrisIdSuccess({
                data: response,
              }),
            ];
          }),
          catchError((error) =>
            of(
              USER_MANAGEMENT_ACTIONS.onUpdateEditIrisIdFailure({
                error: error,
              }),
            ),
          ),
        ),
      ),
    ),
  );

  /*
   * @DIALOG ACTIONS
   * */
  openUserManagementDialog$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(USER_MANAGEMENT_DIALOG_ACTIONS.openUserManagementDialog),
        tap(({ component, data }) => {
          this._matDialog.open(component(), {
            data: data,
          });
        }),
      ),
    {
      dispatch: false,
    },
  );

}
